import React from 'react';
import location from '../../../images/icons/ic-location-dark.svg';
import coordinates from '../../../images/icons/ic-coordinates.svg';
import elevation from '../../../images/icons/ic-elevation.svg';
import SegmentType from '../../SegmentType';
import { formatDuration } from '../../../src/js/lib/duration';
import { formatPosition } from '../../../src/js/lib/position';

const Item = ({ segment, index }) => (
  <a
    href={segment.url}
    className='block 2xl:flex items-start justify-between w-full p-3 mt-2 segment__item bg-background-quinary 2xl:bg-transparent rounded'
  >
    <div className='flex-1 shrink items-center small-body-text 2xl:flex 2xl:justify-between mb-2 2xl:mb-0 min-w-0'>
      <div className='items-center mb-2 2xl:mb-0 flex min-w-0'>
        <div className='flex items-center mr-2'>
          <span className='pr-2 mini-label text-text-grey-600 min-w-[2rem]'>
            S{index + 1}
          </span>
          <SegmentType typeIconUrl={segment.sport_icon_url} />
        </div>
        <h3 className='font-medium small-body-text mb-2 ml-1 md:mb-0 md:ml-0 truncate min-w-0 2xl:pr-4'>
          {segment.name}
        </h3>
      </div>
      <div className='border-border-secondary 2xl:w-[10rem] 2xl:flex justify-start pl-6 segment__position shrink-0'>
        <div className='flex'>
          <p className='mb-0'>
            #{' '}
            <span>
              {formatPosition(segment.current_user_segment_effort?.position)}
            </span>
          </p>
          {segment.current_user_segment_effort?.duration ? (
            <p className='mb-0 ml-5'>
              <span>
                {formatDuration(segment.current_user_segment_effort.duration)}
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </div>

    <div className='shrink-0 flex 2xl:justify-end small-body-text 2xl:w-2/5 segment__stats flex-wrap 2xl:flex-nowrap 2xl:pl-6'>
      <div className='flex items-center mr-4 text-text-grey-600 min-w-0'>
        <img src={location} className='w-3 mr-2' />
        <span className='truncate'>{segment.city}</span>
      </div>
      <div className='flex items-center shrink-0 mr-4 text-text-grey-600 w-[6rem]'>
        <img src={coordinates} className='w-[0.875rem] mr-2' />
        <span>{(segment.distance_in_meters / 1000).toFixed(1)} km</span>
      </div>
      <div className='flex items-center shrink-0 text-text-grey-600 w-[4.5rem]'>
        <img src={elevation} className='w-[0.875rem] mr-2' />
        <span>
          {segment.elevation ? parseFloat(segment.elevation).toFixed(0) : '00'}m
        </span>
      </div>
    </div>
  </a>
);

export default Item;
